import React from 'react';

/**
 * Iconos SVG inline para la Calculadora BCV.
 * Se definen aquí (en lugar de usar una librería de iconos) para mantener el
 * componente totalmente portable y sin dependencias externas.
 * Todos heredan el color mediante `currentColor`.
 */

export const CalculatorIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="4" y="2" width="16" height="20" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
    <rect x="7" y="5" width="10" height="3.5" rx="1" fill="currentColor" />
    <circle cx="8" cy="12.5" r="1.1" fill="currentColor" />
    <circle cx="12" cy="12.5" r="1.1" fill="currentColor" />
    <circle cx="16" cy="12.5" r="1.1" fill="currentColor" />
    <circle cx="8" cy="16.5" r="1.1" fill="currentColor" />
    <circle cx="12" cy="16.5" r="1.1" fill="currentColor" />
    <circle cx="16" cy="16.5" r="1.1" fill="currentColor" />
  </svg>
);

export const CloseIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6 6l12 12M18 6L6 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const CalendarIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="3.5" y="5" width="17" height="15" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3.5 9.5h17" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const CoinIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M12 7v10M14.5 9.2c0-1.1-1.1-1.9-2.5-1.9s-2.5.8-2.5 1.9.9 1.6 2.5 1.9c1.6.3 2.5.9 2.5 1.9 0 1.1-1.1 1.9-2.5 1.9s-2.5-.8-2.5-1.9"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const CopyIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="9" y="9" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M5 15H4.5A1.5 1.5 0 013 13.5V4.5A1.5 1.5 0 014.5 3h9A1.5 1.5 0 0115 4.5V5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const CheckIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5 12.5l4.5 4.5L19 7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRightIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9 6l6 6-6 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
